import helpers from './helpers.module.css';
import layout from './layout.module.css';

const sharedStyles = { ...helpers, ...layout };

export default sharedStyles;
